module.exports = __webpack_public_path__ + "v1.0.0/img/page_loading.80b14bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/page_loading.svg
// module id = NHdK
// module chunks = 1